

















































import Vue from 'vue';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  props: {
    drillCompleted: Boolean,
    quizCompleted: Boolean,
    courseCompleted: Boolean,
    averageScore: Number,
  },
  mounted() {
    Vue.prototype.$donePlayer.play();
  },
  computed: {
    titleText(): string {
      // fixme course completed
      if (this.drillCompleted) {
        return this.$store.state.tr.DrillCompleted;
      }
      if (this.quizCompleted) {
        return this.$store.state.tr.QuizCompleted;
      }
      return '';
    },
    messageText(): string {
      if (this.$route.path.startsWith(RoutePaths.DRILL_FLASHCARDS)) {
        return this.$store.state.tr.NoFlashcards;
      }
      if (this.$route.path.startsWith(RoutePaths.DRILL_VOICECOMPARISON)) {
        return this.$store.state.tr.VoiceCompareActivity;
      }
      return '';
    },
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
  },
});
